import _ from 'lodash'
import {
  ActionStore,
  ChecklistStore,
  GroupedItemVM, GroupedItemsVM,
  ImageMarkerVM, ImageMarkersVM,
  ItemVM, RuleVM,
  TemplateStore, TemplateHistoryItemStore
} from "@cmodules/checklist/assets/data/types"
import { syncRelations } from "@cmodules/checklist/utility/templateBuilderContext-new"
import { AnyItemVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/item"

let tempState: ChecklistStore
let selectedItemsForMultipleSelection: string[]

export const handleTemplateSetSelectedItem = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  tempState = { ...state }
  tempState.ui.currentItem = action.payload
  tempState.ui.currentSubItem = {} as AnyItemVM
  tempState.ui.multipleItems = {}
  tempState.ui.callStack = []
  let currentItem = action.payload
  if (action.payload.expandItems) {
    let foundItem = tempState.template.present.items.find(x => x.id === currentItem.id)
    while (foundItem?.collapsed) {
      foundItem.collapsed = false
      currentItem = foundItem
      foundItem = tempState.template.present.items.find(x => x.id === currentItem.id)
    }
  }
  return tempState
}

export const handleTemplateSetSelectedSubItem = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  tempState = { ...state }
  const currentItem = state.template.present.items.find(x => x.id === action.payload.callStack[0])
  if (currentItem) {
    tempState.ui.currentItem = currentItem
  }
  tempState.ui.currentSubItem = action.payload.item
  tempState.ui.multipleItems = {}
  tempState.ui.callStack = action.payload.callStack
  // let currentItem = action.payload
  // if (action.payload.expandItems) {
  //   let foundItem = tempState.template.present.items.find(x => x.id === currentItem.id)
  //   while (foundItem?.collapsed) {
  //     foundItem.collapsed = false
  //     currentItem = foundItem
  //     foundItem = tempState.template.present.items.find(x => x.id === currentItem.id)
  //   }
  // }
  return tempState
}

export const handleSubTemplateEdit = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  const clk_template_edit_data: TemplateHistoryItemStore = action.payload.template
  const global_item_key: string = action.payload.global_item_key
  tempState = _.cloneDeep(state)
  const currentSubTemplate = _.cloneDeep(tempState.template.global_items?.[global_item_key ?? ''])
  if (currentSubTemplate.present.template_id) {
    return {
      ...tempState,
      template: {
        ...tempState.template,
        global_items: {
          ...tempState.template.global_items,
          [global_item_key]: {
            ...currentSubTemplate,
            present: clk_template_edit_data
          }
        }
      }
    }
  } else {
    return tempState
  }

}

export const handleTemplateToggleMultiSelectMode = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  if (!state.multiSelectMode && action.payload || state.multiSelectMode && !action.payload) {
    tempState = { ...state }
    tempState.ui.multipleItems = {}
    tempState.ui.currentItem = {} as AnyItemVM
    tempState.ui.currentSubItem = {} as AnyItemVM
    tempState.multiSelectMode = action.payload
    return tempState
  } else {
    return state
  }
}

export const handleTemplateEmptyMultiSelectItems = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  tempState = { ...state }
  tempState.ui.multipleItems = {}
  tempState.ui.currentItem = {} as AnyItemVM
  tempState.ui.currentSubItem = {} as AnyItemVM
  tempState.ui.callStack = []
  return tempState
}

const getMultiSelectPayloadAsArray = (selected: string | string[]): string[] => {
  const finalSelected: string[] = []
  if (_.isArray(selected)) {
    _.forEach(selected, selectedItemUUID => {
      finalSelected.push(selectedItemUUID)
    })
  } else {
    finalSelected.push(selected)
  }
  return finalSelected
}

export const handleTemplateSetMultipleSelectedItems = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  tempState = _.cloneDeep(state)
  selectedItemsForMultipleSelection = getMultiSelectPayloadAsArray(action.payload)
  const isDelete = tempState.ui.multipleItems[_.first(selectedItemsForMultipleSelection) || '']
  _.forEach(selectedItemsForMultipleSelection, currentSelectedItemUUID => {
    if (isDelete) {
      delete tempState.ui.multipleItems[currentSelectedItemUUID]
    } else {
      tempState.ui.multipleItems = {
        ...tempState.ui.multipleItems,
        [currentSelectedItemUUID]: true
      }
      tempState.multiSelectMode = true
    }
  })
  tempState.ui.callStack = []
  return tempState
}

export const SelectItemCases = {
  CLK_SUB_TEMPLATE_EDIT: handleSubTemplateEdit,
  CLK_TEMPLATE_SET_SELECTED_ITEM: handleTemplateSetSelectedItem,
  CLK_TEMPLATE_SET_SELECTED_SUB_ITEM: handleTemplateSetSelectedSubItem,
  CLK_TEMPLATE_TOGGLE_MULTI_SELECT_MODE: handleTemplateToggleMultiSelectMode,
  CLK_TEMPLATE_EMPTY_MULTI_SELECT_ITEMS: handleTemplateEmptyMultiSelectItems,
  CLK_TEMPLATE_SET_SINGLE_TO_MULTIPLE_SELECTED_ITEMS: handleTemplateSetMultipleSelectedItems,
  CLK_TEMPLATE_SET_MULTI_TO_MULTIPLE_SELECTED_ITEMS: handleTemplateSetMultipleSelectedItems
}

export type SelectItemActionType = keyof typeof SelectItemCases
export const SELECT_ITEM_ACTION_TYPES: { [K in SelectItemActionType]: K } = Object.fromEntries(
  Object.keys(SelectItemCases).map((key) => [key, key])
) as { [K in SelectItemActionType]: K }

export type ActionHandler = typeof SelectItemCases[SelectItemActionType]
